import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Features from '../components/Features';
import VideoSection from '../components/VideoSection';
import Expectations from '../components/Expectations';
import Conferences from '../components/Conferences';
import Sessions from '../components/Sessions';
import Networking from '../components/Networking';
import Sponsors from '../components/Sponsors';
import EventPhotos from '../components/EventPhotos';
import Magazine from '../components/Magazine';
import CTA from '../components/CTA';
import About from '../components/About';
import Partners from '../components/Partners';
import styles from './HomePage.module.css';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Brands 2 Buyers | SUMMER Edition — 25 Juin 2026 à Paris</title>
        <meta name="description" content="Rejoignez-nous le 25 juin 2026 en format afterwork à Paris pour Brands 2 Buyers | SUMMER Edition, l'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta property="og:title" content="Brands 2 Buyers | SUMMER Edition — 25 Juin 2026 à Paris" />
        <meta property="og:description" content="Rejoignez-nous le 25 juin 2026 en format afterwork à Paris pour Brands 2 Buyers | SUMMER Edition, l'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta property="og:image" content="https://brands2buyers.io/assets/images/logo.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Brands 2 Buyers | SUMMER Edition — 25 Juin 2026 à Paris" />
        <meta name="twitter:description" content="Rejoignez-nous le 25 juin 2026 en format afterwork à Paris pour Brands 2 Buyers | SUMMER Edition, l'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta name="twitter:image" content="https://brands2buyers.io/assets/images/logo.png" />
      </Helmet>
      <Hero />
      <Partners />
      <Features />
      <VideoSection />
      <Expectations />
      <div
        className={styles.premiumWrapper}
      >
        <Conferences />
        <Sessions />
        <Networking />
      </div>
      <Sponsors />
      <EventPhotos />
      <Magazine />
      <CTA />
      <About />
    </>
  );
};

export default HomePage;
